import { DocumentType } from '../../../enums/document-type';
import { locationBarcode } from '../document-type-epic-helpers/location-barcode';
import * as Api from '../print.api';
import { jobRunner } from './job-runner';

/**
 * @typedef {import('./print-job-factory').PrintJob} PrintJob
 */

/**
 * @param {object} args
 * @param {Array<{inventoryLocationId: string, area: string, unit: string, shelf: string, bin: string, barcode: string}>} args.locations
 * @param {string} args.printType
 * @param {object} [args.printer] - can be omitted if doing something like downloading
 * @param {number} [args.pusherTimeoutMs]
 * @returns {import('rxjs').Observable<PrintJob>}
 */
export const createLocationBarcodeAsync = ({ locations, printType, printer, pusherTimeoutMs }) => {
  const documentCount = locations.length;
  const notification = locationBarcode.getAsyncPrintStartedNotificationProps(documentCount);
  const errorNotification = locationBarcode.getAsyncPrintFailedNotificationProps(documentCount);
  const locationIds = locations.map((location) => location.inventoryLocationId);
  return jobRunner({
    apiRequest: () => Api.generateLocationBarcodesAsync(locations, printType),
    documentCount,
    documentTypeIdentifier: DocumentType.LocationBarcode.identifier,
    initialNotification: notification,
    errorNotification,
    ids: locationIds,
    printer,
    pusherTimeoutMs,
  });
};
